import * as React from 'react';

import classnames from 'classnames';

import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import type {SectionEntity} from './types';

import entityColors from './entity-colors.module.css';
import styles from './section-add-item-button.module.css';

type Props = {
    sectionEntity: SectionEntity;
    // Used as `+ Add [parentItemText] [entityType]`
    parentItemText?: React.ReactNode;
    omitEntityName?: boolean;
    onAddItem: () => void;
};

export function EntityPageAddItemButton(props: Props) {
    const {sectionEntity, parentItemText, onAddItem, omitEntityName} = props;

    const entityType = getSingularEntityType(sectionEntity);
    const addItemStyleNames = classnames(
        styles['add-item-button'],
        // @ts-expect-error
        entityColors[entityType] // Apply entity-specific color styles
    );

    return (
        <button
            type='button'
            onClick={(e) => {
                e.preventDefault();
                onAddItem();
            }}
            className={addItemStyleNames}
        >
            + Add {parentItemText ? parentItemText : ''}
            {omitEntityName ? undefined : getSingularEntityType(sectionEntity)}
        </button>
    );
}
